import { Feature, GeoJsonProperties, Point } from "geojson";

export const convertValueToString = (value: Feature<Point, GeoJsonProperties> | null): string =>
  value
    ? value.properties?.name ||
      `[${value.geometry.coordinates[0].toFixed(5)}, ${value.geometry.coordinates[1].toFixed(5)}]`
    : "";
